import * as loginActions from '../login/actions';
import * as barsActions from './actions';
import {Record} from 'immutable';

const State = Record({
    bar: null
});

const BAR = 'bar';

const barReducer = (state = new State(), action) => {

    switch (action.type) {
        case barsActions.CHOOSE_BAR: {
            return state.set(BAR, action.payload.bar);
        }
        case loginActions.API_LOGOUT: {
            return state.set(BAR, null);
        }
    }

    return state;
};

export default barReducer;



// WEBPACK FOOTER //
// ./src/common/bars/reducer.js